import type { PracticeAccessSource } from '@nesso/practice-contracts/practice-access-rule.access-sources';

export const PROFILE_CREDENTIALS_REQUIRED_ACCESS_SOURCES: PracticeAccessSource[] = [
    'CLINICIAN',
    'EHR_BASE',
];
